module.exports = __webpack_public_path__ + "media/src/images/logos/youtube-logo-ee212a6b949817324e7bcfd4a1f3b317.png";